import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-load-more-button',
  templateUrl: './load-more-button.component.html',
  styleUrls: ['./load-more-button.component.scss']
})
export class LoadMoreButtonComponent implements OnInit {

  /**
   *  Input property for indicate if data is loading
   *
   * @memberof LoadMoreButtonComponent
   */
  @Input() loading: boolean;

  /**
   * Input property for indicate if there's more data and render the load more button
   *
   * @memberof LoadMoreButtonComponent
   */
  @Input() areMoreData: boolean;

  /**
   * Input property that if a function to be called when Load More button is clicked
   *
   * @memberof LoadMoreButtonComponent
   */
  @Output() loadMore = new EventEmitter();

  /**
   * A Property to be pass for set the msg when there's no results.
   * Default to No results, but if set undefined would not show anything
   *
   * @type {string}
   * @memberof LoadMoreButtonComponent
   */
  @Input() noResultsMsg: string = "No results";

  constructor() { }

  ngOnInit() {
    if (this.loading == null) {
      throw new Error('No input for loading have been provided, please use it as this example <app-load-more-button [loading]="myCondition"');

    }
    if (this.areMoreData == null) {
      throw new Error('No input for areMoreData have been provided, please use it as this example <app-load-more-button [areMoreData]="myCondition"');
    }

  }

  /**
   * Inner call of function for call event emitter
   *
   * @memberof LoadMoreButtonComponent
   */
  loadMoreClick() {
    this.loadMore.emit();
  }
}
